export function find(
  element: HTMLElement | undefined,
  selector: string,
): HTMLElement[] {
  if (!element) {
    return [];
  }

  return Array.from(element.querySelectorAll(selector));
}
